import { Sprite, Text, TextStyle } from 'pixi.js'
import { FT, Tween, Easing } from 'ft'

const base = {
  fontFamily: 'custom-font',
  fontSize: 48,
  lineHeight: 64,
}

const textCold = {
  fill: '#ffffff',
}

const textWarm = {
  fill: '#98462c',
}

const alignLeft = {
  align: 'left',
}

const alignCenter = {
  align: 'center',
}

class Dialog extends Sprite {
  constructor(
    text,
    { align = 'left', next = true, theme = 'warm' } = {},
    onPointerup
  ) {
    super(FT.rm.texture(`share-dialog-${theme}`))
    this.anchor.set(0.5, 0)
    this.x = FT.stage.centerX
    this.y = FT.stage.bounds.bottom - 300

    if (onPointerup) {
      this.interactive = true
      this.once('pointerup', onPointerup)
    }

    const style = {}
    Object.assign(style, base)
    Object.assign(style, theme === 'warm' ? textWarm : textCold)

    const y = 46
    let t, x, anchor
    switch (align) {
      case 'left':
        x = 60 - this.width / 2
        Object.assign(style, alignLeft)
        anchor = [0, 0]
        break
      case 'center':
      default:
        x = 0
        Object.assign(style, alignCenter)
        anchor = [0.5, 0]
    }

    t = new Text(text, new TextStyle(style))
    t.anchor.set(...anchor)
    t.position.set(x, y)
    this.addChild(t)

    if (next) {
      const buttonNext = new Sprite(FT.rm.texture('share-button-next'))
      buttonNext.anchor.set(0.5, 0)
      buttonNext.x = 275
      buttonNext.y = 170
      const tween = new Tween(buttonNext)
        .to({ y: 150 }, 400)
        .easing(Easing.Exponential.Out)
        .yoyo(true)
        .repeat(Number.POSITIVE_INFINITY)
      tween.start()
      this.on('removed', () => {
        tween.stop()
      })
      this.addChild(buttonNext)
    }
  }
}

export default Dialog
